import { z } from "zod";

export const GenerateEllipseSchema = z.object({
  downstreamDistanceMeters: z.number().positive(),
  upstreamDistanceMeters: z.number().positive(),
  perpendicularDistanceMeters: z.number().positive(),
  azimuthDegrees: z.number().min(0).max(360),
  numPoints: z.number().int().optional(),
});

export type GenerateEllipse = z.infer<typeof GenerateEllipseSchema>;